import React from 'react';

function SingleBannerCarouselSkeleton() {
  return (
    <section className="single-banner-carousel-skeleton animate-pulse bg-skeleton shadow-trending-categories-search relative w-full max-w-full" />
  );
}

export default SingleBannerCarouselSkeleton;
